<template>
  <v-card class="px-7 pb-5 mt-10" style="width: 100%" outlined>
    <div class="d-flex align-start justify-center mb-5">
      <v-avatar :style="`border-color: #${this.$store.state.clubMember.club.primaryColor} !important;`" class="avatar-special mt-n12" size="100">
        <v-img :src="this.$store.state.clubMember.club.imageUrl" contain></v-img>
      </v-avatar>
    </div>
    <h1 class="text-center">{{ this.$store.state.clubMember.club.name }}</h1>
    <p class="text-center mb-7">{{ $t('message', { rol: getRol() }) }}</p>
    <div v-if="$store.state.clubMember.rol !== 'MEMBER'" class="d-flex justify-center">
      <v-chip @click="goToSettings" small>{{ $t('settingsBtn') }} <v-icon class="ml-2" x-small>fa-cog</v-icon></v-chip>
    </div>
    <v-chip class="d-flex justify-center mt-2" :color="`#${this.$store.state.clubMember.club.primaryColor}`" outlined>{{ `${activeMembers} ${$t('activeMembers')}` }}</v-chip>
    <v-divider class="my-7"/>
    <h3 class="text-center mb-3">{{ $t('upcomingEvents.title') }} {{ capitalize(this.$store.state.currentClubChannel.name) }}</h3>
    <p v-if="events.length === 0" class="text-center">{{ $t('upcomingEvents.noEvents') }}</p>
    <v-list>
      <v-list-item-group>
        <v-list-item v-bind:key="event.id" v-for="event in events" @click="goToEvents">
          <v-list-item-icon><v-icon class="mt-2" small>fa-calendar-day</v-icon></v-list-item-icon>
          <v-list-item-content class="ml-n2">
            <v-list-item-title v-text="`${event.name}`"></v-list-item-title>
            <v-list-item-subtitle>
              <p class="mb-0">
                {{ monthNames[new Date(event.startDate).getMonth()]}} {{ new Date(event.startDate).getDate()}} /{{new Date(event.startDate).getFullYear().toString()}} {{String(new Date(event.startDate).getHours()).padStart(2, '0')}}:{{String(new Date(event.startDate).getMinutes()).padStart(2, '0') }}
              </p>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/club';
import { mapMutations } from 'vuex';
export default {
  name: "ClubController",
  data() {
    return {
      monthNames: [
        this.$t('months.jan'),
        this.$t('months.feb'),
        this.$t('months.mar'),
        this.$t('months.apr'),
        this.$t('months.may'),
        this.$t('months.jun'),
        this.$t('months.jul'),
        this.$t('months.aug'),
        this.$t('months.sep'),
        this.$t('months.oct'),
        this.$t('months.nov'),
        this.$t('months.dec')
      ],
      datePicker: null,
      events: [],
      pendingMembers: [],
    };
  },
  computed: {
    activeMembers() {
      return this.$store.state.clubMembers.length - this.pendingMembers.length;
    }
  },
  watch: {
    '$store.state.clubEvents': function () {
      this.processEvents();
    },
    '$store.state.clubMembers': function () {
      this.seePendingRequests();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getEvents();
      this.getMembers();
      this.getClubChannelsContributedByMe();
      this.getClubPublicChannels();
      //if(this.$store.state.clubMember.rol === 'FOUNDER' || this.$store.state.clubMember.rol === 'ADMIN')
      //  this.getClubChannels();
    },
    getRol() {
      return (this.$store.state.clubMember.rol === 'FOUNDER')? this.$t('roles.founder') :
          (this.$store.state.clubMember.rol === 'ADMIN')? this.$t('roles.admin') : this.$t('roles.member');
    },
    ...mapMutations(['setClubEvents']),
    getEvents() {
      Repository.getAllClubEventsByChannel(this.$store.state.clubMember.club.id, this.$store.state.currentClubChannel.id).then((response) => {
        if(response.status < 400) {
          this.setClubEvents(response.data);
          this.processEvents();
        }
      });
    },
    ...mapMutations(['setClubMembers']),
    getMembers() {
      Repository.getAllClubMembers(this.$store.state.clubMember.club.id).then((response) => {
        if(response.status < 400) {
          this.setClubMembers(response.data);
          this.seePendingRequests();
        }
      });
    },
    ...mapMutations(['setClubChannels']),
    getClubChannels() {
      Repository.getAllClubChannels(this.$store.state.clubMember.club.id).then((response)=> {
        if(response.status < 400)
          this.setClubChannels(response.data);
      });
    },
    ...mapMutations(['setClubChannelsContributedByMe']),
    getClubChannelsContributedByMe() {
      Repository.getAllClubChannelsByContributor(this.$store.state.clubMember.id).then((response) => {
        if(response.status < 400)
          this.setClubChannelsContributedByMe(response.data);
      });
    },
    ...mapMutations(['setClubPublicChannels']),
    getClubPublicChannels() {
      Repository.getAllPublicClubChannels(this.$store.state.clubMember.club.id).then((response) => {
        if(response.status < 400) {
          this.setClubPublicChannels(response.data);
          this.processEvents();
        }
      });
    },
    processEvents() {
      let now = new Date();
      this.events = [];
      this.$store.state.clubEvents.forEach((event) => {
        if(new Date(event.startDate) > now)
          this.events.push(event);
      })
    },
    seePendingRequests() {
      this.pendingMembers = [];
      this.$store.state.clubMembers.forEach((member) => {
        if(member.rol === 'PENDING')
          this.pendingMembers.push(member);
      });
    },
    goToEvents() {
      this.$router.push('/club/events');
    },
    goToSettings() {
      this.$router.push('/club/settings');
    },
    capitalize(string) {
      return string[0] + string.slice(1).toLowerCase();
    },
  }
}
</script>

<i18n>
{
  "en": {
    "message": "{rol} of this community",
    "activeMembers": "Active Members",
    "roles": {
      "founder": "Founder",
      "admin": "Admin",
      "member": "Member",
      "pending": "Pending Member"
    },
    "upcomingEvents": {
      "title": "Upcoming events for",
      "noEvents": "No upcoming events"
    },
    "months": {
      "jan" : "January",
      "feb" : "February",
      "mar" : "March",
      "apr" : "April",
      "may" : "May",
      "jun" : "June",
      "jul" : "July",
      "aug" : "August",
      "sep" : "September",
      "oct" : "October",
      "nov" : "November",
      "dec" : "December"
    },
    "settingsBtn": "Settings"
  },
  "es": {
    "message": "{rol} de esta comunidad",
    "activeMembers": "Miembros Activos",
    "roles": {
      "founder": "Fundador",
      "admin": "Administrador",
      "member": "Miembro",
      "pending": "Miembro Pendiente"
    },
    "upcomingEvents": {
      "title": "Eventos próximos en",
      "noEvents": "No hay eventos cercanos"
    },
    "months": {
      "jan" : "Enero",
      "feb" : "Febrero",
      "mar" : "Marzo",
      "apr" : "Abril",
      "may" : "Mayo",
      "jun" : "Junio",
      "jul" : "Julio",
      "aug" : "Agosto",
      "sep" : "Septiembre",
      "oct" : "Octubre",
      "nov" : "Noviembre",
      "dec" : "Diciembre"
    },
    "settingsBtn": "Ajustes"
  }
}
</i18n>

<style scoped>
  .avatar-special {
    border: 2px solid !important;
    border-radius: 500px !important;
  }
</style>
